import { IActivity } from 'types';
import { activityTypeEnum } from 'types/store/activityEnums';

export const useActivityMapper = () => {
  const handleNewActivity = (existingActivities: IActivity[], newActivity: IActivity): IActivity[] => {
    let newActivityList = [...existingActivities];

    if (newActivity.activityTypeName === activityTypeEnum.Mention) {
      // Always add mention activity but remove any comment activity from that group
      newActivityList.unshift(newActivity);
      let hasCommentActivity = newActivityList.some(
        (item) =>
          item.activityDate === newActivity.activityDate &&
          item.activityInitiatorId === newActivity.activityInitiatorId &&
          item.activityTypeName === activityTypeEnum.Comment
      );
      if (!hasCommentActivity) {
        return newActivityList;
      }
      return newActivityList.filter((activity) =>
        activity.activityDate === newActivity.activityDate &&
        activity.activityInitiatorId === newActivity.activityInitiatorId &&
        activity.activityTypeName === activityTypeEnum.Comment
          ? false
          : true
      );
    } else if (newActivity.activityTypeName === activityTypeEnum.Comment) {
      // Only add comment activity if there is no mention activity for that group
      let hasMentionActivity = newActivityList.some(
        (item) =>
          item.activityDate === newActivity.activityDate &&
          item.activityInitiatorId === newActivity.activityInitiatorId &&
          item.activityTypeName === activityTypeEnum.Mention
      );
      if (hasMentionActivity) {
        return newActivityList;
      }
    }

    // Check if an activity with the same group already exists
    let existingActivityIndex = newActivityList.findIndex(
      (item) => item.activityDate === newActivity.activityDate && item.activityInitiatorId === newActivity.activityInitiatorId
    );

    // If no activity for that group, add new
    // If activity for that group exists but new activity is assignment (previous would be created or updated), update with assignment activity
    // Else dont add new activity - although user activity should trump team activity, both activities would display the same way
    if (existingActivityIndex === -1) {
      newActivityList.unshift(newActivity);
    } else if (newActivity.activityTypeName === activityTypeEnum.Assignment) {
      newActivityList.splice(existingActivityIndex, 1, newActivity);
    }

    return newActivityList;
  };

  return {
    handleNewActivity
  };
};
